/**
 * 私製はがき（通常・L サイズ・変形サイズ）の注文（価格表の表示とカート追加）
 * MEMO: 旧 js/order-hagaki-shisei.js の ESM 版
 *       用紙・オプション・加工の選択 UI は、src/order-common が #j-nxg_* の hidden input に値を入れる
 */
import '@/order-common'
import { setPriceLoader } from '@/order-common/price-loader'
import { onReady } from '@/utils/dom'
import { createPriceTableLoader, initPriceLinkAddCart } from '@/utils/order-price-table'

//印刷タイプ（片面白黒・両面白黒・片面カラー・カラー×白黒・両面カラー）
const PRINT_TYPES = ['OPT_PRINT_TYPE_1_0', 'OPT_PRINT_TYPE_1_1', 'OPT_PRINT_TYPE_4_0', 'OPT_PRINT_TYPE_4_1', 'OPT_PRINT_TYPE_4_4']
//1 セットずつ表示する行数（99 セット・990 枚まで）と、それ以降の表示の間隔（10 セット・100 枚ごと）
const EVERY_SET_ROWS = 99
const ROW_STEP_AFTER = 10

/**
 * 表に出す行（99 セットまでは 1 セットごと、100 セット以降は 10 セットごと）
 */
const getRowIndexes = (rowCount: number): number[] => {
    const indexes = [...Array(Math.min(rowCount, EVERY_SET_ROWS)).keys()]
    for(let index = EVERY_SET_ROWS; index < rowCount; index += ROW_STEP_AFTER) indexes.push(index)
    return indexes
}

const loadPriceTable = createPriceTableLoader({
    printTypes: PRINT_TYPES,
    maxLotAmount: 300,
    endPoint: 'list-base-prices',
    unitNum: 10,
    lotName: 'セット',
    getLayout: () => ({
        pc: PRINT_TYPES,
        mobile: [
            ['#order-price_table_mobile-01 tbody', ['OPT_PRINT_TYPE_1_0', 'OPT_PRINT_TYPE_1_1', 'OPT_PRINT_TYPE_4_0']],
            ['#order-price_table_mobile-02 tbody', ['OPT_PRINT_TYPE_4_1', 'OPT_PRINT_TYPE_4_4']],
        ],
    }),
    getRowIndexes,
})

onReady(() => {
    setPriceLoader(loadPriceTable)
    loadPriceTable()
    initPriceLinkAddCart()
})
